<mat-card>
    <mat-card-header>
        <mat-card-title>
            <prl-label value='label.marketing.tools.invocation.code'/>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @for (i of (showAllVars ? indexes : indexes.slice(0, 3)); track i) {
            <mx-text-field
                    [form]="form"
                    [label]="'label.add.var' + i"
                    [name]="'var' + i">
            </mx-text-field>
        }

    </mat-card-content>

    <mat-card-actions>
        <mx-button [buttonModel]="expandButton"></mx-button>
        <mx-button [buttonModel]="cancelButton"></mx-button>
        <mx-button [buttonModel]="submitButton"></mx-button>
    </mat-card-actions>
</mat-card>
